var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.125 12C24.125 5.578 18.922.375 12.5.375S.875 5.578.875 12c0 5.813 4.219 10.64 9.797 11.484v-8.109H7.719V12h2.953V9.469c0-2.906 1.734-4.547 4.36-4.547 1.312 0 2.624.234 2.624.234v2.86h-1.453c-1.453 0-1.922.89-1.922 1.828V12h3.235L17 15.375h-2.719v8.11c5.578-.844 9.844-5.672 9.844-11.485z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.04dec0e8.svg";
export { ForwardRef as ReactComponent };